import { useHistory } from 'react-router-dom';
import { CONTACT_QUERY_PARAMS } from 'features/inventory-profiles/constants';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { useUserContext } from 'providers/UserProvider';
import { EntityRoutes } from 'routes/constants';
import { canUserOrStaffEditEntity, Permissions, userHasPermission } from 'services/Authorization';
import { FeatureFlags } from 'UI/constants/featureFlags';

/**
 * What the current user may see or do on a Contact profile.
 * @param {Object} contact Contact profile
 * @returns {Object} Named booleans
 */
export const useContactPermissions = contact => {
  const [user] = useUserContext();
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  return {
    canEdit: canUserOrStaffEditEntity(user, contact),
    canUseDailyPlan:
      checkIfFeatureFlagEnabled(FeatureFlags.DailyPlanAddTaskFromProfile) &&
      userHasPermission(Permissions.DailyPlan.CanUseModule),
    canRequestDoNotContact: checkIfFeatureFlagEnabled(FeatureFlags.RequestDoNotContactFromProfile),
    canRequestDoNotEngage: checkIfFeatureFlagEnabled(FeatureFlags.RequestDoNotEngageFromProfile),
    canAddCandidate: checkIfFeatureFlagEnabled(FeatureFlags.NewCandidateFromContact),
    canSeeDataSheet: checkIfFeatureFlagEnabled(FeatureFlags.ContactsDataSheetTab)
  };
};

/**
 * Navigation of the Contact profile.
 * @param {Object} params
 * @param {number|string} params.id Contact (name) id
 */
export const useContactNavigation = ({ id }) => {
  const history = useHistory();

  const addCandidate = () =>
    history.push(`${EntityRoutes.CandidateCreate}?${CONTACT_QUERY_PARAMS.ContactId}=${id}`);

  const openDailyPlan = () => history.push(EntityRoutes.DailyPlan);

  return {
    addCandidate,
    openDailyPlan
  };
};
